import * as React from 'react';
import classes from './index.module.scss.js';

const FormGroup = (props) => {
    const { disabled, children } = props;
    const childrenWithProps = React.Children.map(children, (child) => {
        // Check if the item is clonable before cloning
        // A null child can be passed, we shouldn't fail.
        if (React.isValidElement(child)) {
            return React.cloneElement(child, {
                disabled,
            });
        }
        else {
            return null;
        }
    });
    return React.createElement("div", { className: classes.container }, childrenWithProps);
};

export { FormGroup };
//# sourceMappingURL=index.js.map
